import { Colors } from '@vetahealth/fishing-gear/colors'
import React, { useEffect, useState } from 'react'
import Animated, { interpolate, useAnimatedStyle, useSharedValue, withSpring } from 'react-native-reanimated'
import styled, { useTheme } from 'styled-components/native'
import { Pressable } from '../Pressable'
import { Text } from '../Text'
import { RadioGroupProps } from './types'

const Wrapper = styled.View``
const ItemWrapper = styled.View`
  flex-direction: row;
  justify-content: space-evenly;
  background-color: ${({ theme }) => theme.colors.secondaryBackground};
  border-radius: ${({ theme }) => theme.borderRadius.xLarge}px;
`
const Radio = styled(Pressable)`
  flex: 1;
  padding: 8px 4px;
  align-items: center;
  justify-content: center;
`
const RadioBackground = styled(Animated.View)`
  position: absolute;
  background-color: ${({ theme }) => theme.colors.tertiaryBackground};
  top: -5;
  bottom: -5;
  left: 0;
  border-radius: ${({ theme }) => theme.borderRadius.xLarge}px;
  box-shadow: 0px 0px 1px ${Colors.black}11;
`

export function RadioButton({ value, onChange, items }: RadioGroupProps): React.ReactNode {
  const theme = useTheme()
  const [width, setWidth] = useState<number>(0)
  const animation = useSharedValue(0)

  const backgroundStyle = useAnimatedStyle(() => ({
    transform: [
      {
        translateX: interpolate(animation.value, [0, items.length], [0, width]),
      },
    ],
  }))

  useEffect(() => {
    if (value !== undefined) {
      const initialIndex = items.findIndex((item) => item.value === value)

      if (initialIndex > -1) animation.value = withSpring(initialIndex)
    }
  }, [])

  function handleOnPress(newValue: string | number, index: number): void {
    animation.value = withSpring(index, { damping: 100, stiffness: 900 })
    onChange(newValue)
  }

  return (
    <Wrapper onLayout={({ nativeEvent }) => setWidth(nativeEvent.layout.width)}>
      <ItemWrapper>
        <RadioBackground style={[{ width: width / items.length }, backgroundStyle]} />
        {items.map((item, index) => {
          const isSelected = item.value === value

          return (
            <Radio
              onPress={() => handleOnPress(item.value, index)}
              key={item.value}
              render={() => (
                <Text
                  weight="semiBold"
                  size="button"
                  isCentered
                  color={isSelected ? theme.colors.primary : theme.colors.text}
                  numberOfLines={1}
                >
                  {item.label}
                </Text>
              )}
            />
          )
        })}
      </ItemWrapper>
    </Wrapper>
  )
}
